import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'rb-input-form-data',
  imports: [RouterOutlet],
  templateUrl: './input-form-data.component.html',
  styleUrl: './input-form-data.component.scss',
})
export class InputFormDataComponent {}
